(function (root) {
  'use strict';

  var OFFER = 'kar98-gifts-unlock-20260827';
  /* AR15 Shadow display-model Gifts Unlock (2026-08-29) shares this guard:
     same _gbk98_* line properties, its own offer token and gift variants. */
  var OFFERS = {
    'kar98-gifts-unlock-20260827': true,
    'ar15-gifts-unlock-20260829': true
  };
  var DEAGLE = 45908710391987;
  var MYSTERY = 45908710457523;
  var AR15_MYSTERY1 = 45916525428915;
  var AR15_MYSTERY2 = 45916525461683;
  var CLUB = 45597242949811;
  var GIFT_MINIMUMS = {};
  GIFT_MINIMUMS[String(DEAGLE)] = 2;
  GIFT_MINIMUMS[String(MYSTERY)] = 3;
  GIFT_MINIMUMS[String(AR15_MYSTERY1)] = 2;
  GIFT_MINIMUMS[String(AR15_MYSTERY2)] = 3;
  var SERVICE_HANDLES = {
    'blaster-club-membership': true,
    /* GB 2026-09-11: the VIP Club mystery gift follows the Club line, so it must
       never count as a real product here — otherwise a Club+gift-only cart would
       look "not empty" and strand both lines. As a service item it is cleared
       together with the Club when the last paid product leaves the cart. */
    'vip-club-mystery-gift': true,
    'shipping-protection': true,
    'giftwrap': true,
    'gift-wrap': true
    /* GB 2026-10-15 (builder 1.4.2): 'blaster-gift-card' is no longer listed. The
       digital gift card is a real product, so a gift-card-only cart is no longer
       emptied on page load and it keeps a Club or service line next to it. */
  };

  /* Build Your Bundle v4 reward. These IDs are a frozen mirror of the private
     candidate config in v4-20261014/server/config/bundle-builder-reward.json. */
  var BUNDLE_REWARD_ID = 'blaster-bundle-gift-5';
  var BUNDLE_REWARD_SELECTOR = BUNDLE_REWARD_ID + ':gift';
  var BUNDLE_REWARD_MYSTERY_MARKER = BUNDLE_REWARD_ID + ':mystery';
  var BUNDLE_REWARD_MYSTERY_PRODUCT = '8403023003827';
  var BUNDLE_REWARD_MYSTERY_VARIANT = '45217054261427';
  var BUNDLE_REWARD_PAID_PRODUCTS = {};
  '8403022250163,8403022381235,8403022479539,8403022741683,8403023167667,8403023265971,8403023331507,8403023593651,8403023691955,8403023757491,8403023790259,8403023823027,8403023855795,8403023954099,8403024019635,8403024117939,8403024281779,8403024314547,8403024347315,8403024380083,8403024412851,8403024445619,8403024478387,8403024511155,8416276906163,8416277135539,8433004052659,8433004904627,8434688753843,8434689015987,8451205169331,8460521799859,8479237439667,8557065339059,8559475425459,8559475785907,8559512158387,8602740293811,8603421540531,8730712637619,8743424917683,8743801487539'.split(',').forEach(function (id) {
    BUNDLE_REWARD_PAID_PRODUCTS[id] = true;
  });
  var BUNDLE_REWARD_GIFT_PRODUCTS = {
    '8403023823027': true,
    '8403023855795': true,
    '8403024117939': true,
    '8403024314547': true,
    '8403024380083': true,
    '8403024412851': true,
    '8403024445619': true,
    '8403024478387': true,
    '8416276906163': true,
    '8433004052659': true,
    '8433004904627': true,
    '8451205169331': true,
    '8460521799859': true,
    '8603421540531': true
  };
  var BUNDLE_REWARD_GIFT_VARIANTS = {
    '45217055998131': '8403023823027',
    '45217056161971': '8403023855795',
    '45217056194739': '8403023855795',
    '45217056227507': '8403023855795',
    '45217056260275': '8403023855795',
    '45217056719027': '8403024117939',
    '45217056751795': '8403024117939',
    '45217056784563': '8403024117939',
    '45217056817331': '8403024117939',
    '45217057145011': '8403024314547',
    '45217057177779': '8403024314547',
    '45217057210547': '8403024314547',
    '45217057276083': '8403024380083',
    '45217057374387': '8403024412851',
    '45217057407155': '8403024412851',
    '45217057439923': '8403024412851',
    '45217057472691': '8403024412851',
    '45271251976371': '8403024412851',
    '45274801864883': '8403024412851',
    '45217057505459': '8403024445619',
    '45217057538227': '8403024445619',
    '45217057570995': '8403024445619',
    '45217057603763': '8403024478387',
    '45217057636531': '8403024478387',
    '45217057669299': '8403024478387',
    '45271387734195': '8403024478387',
    '45263609725107': '8416276906163',
    '45263609757875': '8416276906163',
    '45311623594163': '8433004052659',
    '45311623626931': '8433004052659',
    '45313385791667': '8433004904627',
    '45313385824435': '8433004904627',
    '45352656961715': '8451205169331',
    '45368900190387': '8451205169331',
    '45377839792307': '8460521799859',
    '45377839857843': '8460521799859',
    '45823127388339': '8603421540531',
    '45824128319667': '8603421540531'
  };

  function properties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function quantity(item) {
    var value = Number(item && item.quantity);
    return isFinite(value) && value > 0 ? Math.floor(value) : 0;
  }

  function variantId(item) {
    return Number(item && (item.variant_id || item.id)) || 0;
  }

  function bundleToken(item) {
    return String(properties(item)._gbk98_bundle || '').trim();
  }

  function isExactGift(item) {
    return !!GIFT_MINIMUMS[String(variantId(item))];
  }

  function isOfferLine(item, role) {
    var props = properties(item);
    return !!OFFERS[String(props._gbk98_offer || '')] && props._gbk98_role === role;
  }

  function isServiceItem(item) {
    var handle = String(item && (item.handle || item.product_handle) || '').toLowerCase();
    return variantId(item) === CLUB || !!SERVICE_HANDLES[handle];
  }

  function numericId(value) {
    var text = String(value || '');
    var match = text.match(/(?:\/|^)([0-9]+)$/);
    return match ? match[1] : '';
  }

  function isBundleRewardGiftCandidate(item) {
    var props = properties(item);
    var rawMarker = props._bos_gift;
    var marker = rawMarker == null ? '' : String(rawMarker);
    return marker === BUNDLE_REWARD_ID || marker === BUNDLE_REWARD_MYSTERY_MARKER
      || (String(props._bos_exp || '') === BUNDLE_REWARD_SELECTOR && marker !== '');
  }

  function positivePrice(item) {
    var raw = item && item.price !== undefined && item.price !== null ? item.price : item && item.final_price;
    var value = Number(raw);
    return isFinite(value) && value > 0;
  }

  function oneTimePurchase(item) {
    return !(item && (item.selling_plan_allocation || item.selling_plan || item.sellingPlanAllocation));
  }

  function noTierDiscount(item) {
    var value = properties(item)._gbk98_no_tier;
    return value === true || String(value || '').toLowerCase() === 'true';
  }

  function rewardPaidLine(item) {
    var props = properties(item);
    var hasGiftProperty = Object.prototype.hasOwnProperty.call(props, '_bos_gift') && String(props._bos_gift || '') !== '';
    var product = numericId(item && (item.product_id || item.product && item.product.id));
    return !!BUNDLE_REWARD_PAID_PRODUCTS[product]
      && String(props._bos_exp || '') === BUNDLE_REWARD_SELECTOR
      && !hasGiftProperty
      && !noTierDiscount(item)
      && oneTimePurchase(item)
      && positivePrice(item);
  }

  function validBundleRewardGift(item) {
    var props = properties(item);
    var product = numericId(item && (item.product_id || item.product && item.product.id));
    var variant = String(variantId(item));
    return String(props._bos_exp || '') === BUNDLE_REWARD_SELECTOR
      && String(props._bos_gift || '') === BUNDLE_REWARD_ID
      && !!BUNDLE_REWARD_GIFT_PRODUCTS[product]
      && BUNDLE_REWARD_GIFT_VARIANTS[variant] === product
      && !noTierDiscount(item)
      && oneTimePurchase(item)
      && positivePrice(item);
  }

  function validBundleMysteryGift(item) {
    var props = properties(item);
    var product = numericId(item && (item.product_id || item.product && item.product.id));
    var variant = String(variantId(item));
    return String(props._bos_exp || '') === BUNDLE_REWARD_SELECTOR
      && String(props._bos_gift || '') === BUNDLE_REWARD_MYSTERY_MARKER
      && product === BUNDLE_REWARD_MYSTERY_PRODUCT
      && variant === BUNDLE_REWARD_MYSTERY_VARIANT
      && !noTierDiscount(item)
      && oneTimePurchase(item)
      && positivePrice(item);
  }

  function rewardUnitPrice(item) {
    var raw = item && item.price !== undefined && item.price !== null ? item.price : item && item.final_price;
    var value = Number(raw);
    return isFinite(value) && value > 0 ? value : Infinity;
  }

  function cheaperRewardLine(current, candidate) {
    if (!current) return candidate;
    var price = rewardUnitPrice(candidate);
    var currentPrice = rewardUnitPrice(current);
    return price < currentPrice ? candidate : current;
  }

  function rewardMarketAllowed(cart) {
    var shopify = root.Shopify || {};
    var currencyInfo = shopify.currency || {};
    var market = cart && cart.market;
    var marketCountry = market && typeof market === 'object'
      ? market.countryIsoCode || market.countryCode || (typeof market.country === 'string' ? market.country : market.country && (market.country.isoCode || market.country.iso_code || market.country.code)) || market.isoCode
      : market;
    var localeCountry = cart && cart.localization && cart.localization.country && (cart.localization.country.isoCode || cart.localization.country.iso_code);
    var currencies = [cart && cart.currency, cart && cart.presentment_currency, cart && cart.currency_code,
      market && typeof market === 'object' && (market.currency || market.currencyCode), currencyInfo.active];
    var countries = [shopify.country, cart && cart.country, cart && cart.country_code, localeCountry, marketCountry];
    var rates = [cart && cart.presentmentCurrencyRate, cart && cart.presentment_currency_rate,
      market && typeof market === 'object' && (market.presentmentCurrencyRate || market.currencyRate), currencyInfo.rate];
    var sawCurrency = false;
    for (var i = 0; i < currencies.length; i++) {
      if (currencies[i] === undefined || currencies[i] === null || currencies[i] === '') continue;
      sawCurrency = true;
      if (String(currencies[i]).toUpperCase() !== 'USD') return false;
    }
    if (!sawCurrency) return false;
    for (var c = 0; c < countries.length; c++) {
      if (countries[c] === undefined || countries[c] === null || countries[c] === '') continue;
      if (String(countries[c]).toUpperCase() !== 'US') return false;
    }
    for (var r = 0; r < rates.length; r++) {
      if (rates[r] === undefined || rates[r] === null || rates[r] === '') continue;
      if (Number(rates[r]) !== 1) return false;
    }
    return true;
  }

  function planCartRepairs(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var paidByBundle = {};
    var realProductQuantity = 0;
    var rewardPaidQuantity = 0;
    var rewardMarket = rewardMarketAllowed(cart);
    var updates = {};
    var seenGifts = {};
    var selectedMystery = null;
    var selectedBlaster = null;

    items.forEach(function (item) {
      var token = bundleToken(item);
      if (token && isOfferLine(item, 'paid')) {
        paidByBundle[token] = (paidByBundle[token] || 0) + quantity(item);
      }
      if (rewardPaidLine(item)) {
        rewardPaidQuantity += quantity(item);
      }
      if (!isExactGift(item) && !isBundleRewardGiftCandidate(item) && !isServiceItem(item)) {
        realProductQuantity += quantity(item);
      }
    });

    if (rewardMarket && rewardPaidQuantity >= 4) {
      items.forEach(function (item) {
        if (item && item.key && validBundleMysteryGift(item)) {
          selectedMystery = cheaperRewardLine(selectedMystery, item);
        }
        if (rewardPaidQuantity >= 5 && item && item.key && validBundleRewardGift(item)) {
          selectedBlaster = cheaperRewardLine(selectedBlaster, item);
        }
      });
    }

    items.forEach(function (item) {
      var key = String(item && item.key || '');
      var id = variantId(item);
      var token = bundleToken(item);

      if (isExactGift(item)) {
        var required = GIFT_MINIMUMS[String(id)];
        var valid = !!key && !!token && isOfferLine(item, 'gift') && (paidByBundle[token] || 0) >= required;
        var giftIdentity = token + '|' + id;
        if (!valid || seenGifts[giftIdentity]) {
          if (key) updates[key] = 0;
          return;
        }
        seenGifts[giftIdentity] = true;
        if (quantity(item) !== 1) updates[key] = 1;
        return;
      }

      if (isBundleRewardGiftCandidate(item)) {
        var marker = String(properties(item)._bos_gift || '');
        var selected = marker === BUNDLE_REWARD_MYSTERY_MARKER ? selectedMystery
          : marker === BUNDLE_REWARD_ID ? selectedBlaster : null;
        var validRewardGift = !!key && selected === item;
        if (!validRewardGift) {
          if (key) updates[key] = 0;
          return;
        }
        if (quantity(item) !== 1) updates[key] = 1;
        return;
      }

      if (id === CLUB && isOfferLine(item, 'membership') && realProductQuantity < 1 && key) {
        updates[key] = 0;
      }

      /* A cart whose real products are all gone must not strand service add-ons
         (gift wrap, shipping protection, club): a lone $5.99 wrap line reads as
         "my cart got wiped and left junk". Clear them so the cart goes cleanly
         empty and the drawer renders its real empty state. */
      if (realProductQuantity < 1 && key && isServiceItem(item)) {
        updates[key] = 0;
      }
    });

    return {
      updates: updates,
      changed: Object.keys(updates).length > 0,
      paidByBundle: paidByBundle,
      rewardPaidQuantity: rewardPaidQuantity,
      realProductQuantity: realProductQuantity
    };
  }

  function readJson(fetcher, url, options) {
    return fetcher(url, options || {}).then(function (response) {
      if (!response || !response.ok) throw new Error('gbk98-cart-guard-' + url + '-' + (response && response.status));
      return response.json();
    });
  }

  function reconcileOnce(fetcher, pathname, sections) {
    return readJson(fetcher, '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (cart) {
      var plan = planCartRepairs(cart);
      if (!plan.changed) return { changed: false, cart: cart, updates: {} };
      var payload = {
        updates: plan.updates,
        sections: sections || ['cart-drawer', 'cart-icon-bubble'],
        sections_url: pathname || '/cart'
      };
      return readJson(fetcher, '/cart/update.js?kaching_bundles=true', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        __gbk98FreshPlan: true,
        body: JSON.stringify(payload)
      }).then(function (data) {
        return { changed: true, data: data, updates: plan.updates };
      });
    });
  }

  /* A shared cart snapshot is authoritative enough for a no-op check. If the
     snapshot needs a repair, keep the original fresh-read path so we never
     mutate from stale shared data. */
  function reconcileFromSharedSnapshot(fetcher, pathname, sections) {
    if (!root.GBCart || typeof root.GBCart.readCart !== 'function') {
      return reconcileOnce(fetcher, pathname, sections);
    }
    return root.GBCart.readCart().then(function (knownCart) {
      if (!knownCart || !Array.isArray(knownCart.items)) {
        return reconcileOnce(fetcher, pathname, sections);
      }
      var knownPlan = planCartRepairs(knownCart);
      if (!knownPlan.changed) {
        return { changed: false, cart: knownCart, updates: {} };
      }
      return reconcileOnce(fetcher, pathname, sections);
    }).catch(function () {
      return reconcileOnce(fetcher, pathname, sections);
    });
  }

  /* The server-side Gift Eligibility Guard validation (checkout rule) rejects any
     cart mutation whose RESULT leaves a gift below its paid threshold. A plain
     theme quantity-decrease on a paid bundle line would therefore 422 and strand
     the customer. This planner rewrites such a mutation into ONE atomic
     /cart/update.js that applies the requested change AND drops the now-invalid
     gifts together, so the resulting state is valid and the gift disappears in the
     same paint. Returns null (= pass the request through untouched) on anything
     it does not fully understand. */
  function planMutationAugment(cart, url, bodyText) {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (!/\/cart\/(change|update)\.js/.test(String(url || ''))) return null;
    var hasManagedGift = cart.items.some(function (item) { return isExactGift(item) || isBundleRewardGiftCandidate(item); });
    var hasRecognizedPaidService = !hasManagedGift
      && rewardMarketAllowed(cart)
      && cart.items.some(rewardPaidLine)
      && cart.items.some(isServiceItem);
    if (!hasManagedGift && !hasRecognizedPaidService) return null;
    var body;
    try { body = JSON.parse(String(bodyText || '')); } catch (error) { return null; }
    if (!body || typeof body !== 'object') return null;

    var requested = {};
    if (/\/cart\/change\.js/.test(String(url))) {
      if (!('quantity' in body)) return null;
      var quantityValue = Number(body.quantity);
      if (!isFinite(quantityValue) || quantityValue < 0 || Math.floor(quantityValue) !== quantityValue) return null;
      var target = null;
      if (body.line !== undefined) {
        var index = Number(body.line);
        if (!isFinite(index)) return null;
        target = cart.items[index - 1] || null;
      } else if (body.id !== undefined) {
        var idText = String(body.id);
        if (idText.indexOf(':') >= 0) {
          target = cart.items.filter(function (item) { return String(item.key) === idText; })[0] || null;
        } else {
          var idNumber = Number(idText);
          var idMatches = cart.items.filter(function (item) { return variantId(item) === idNumber; });
          if (idMatches.length !== 1) return null;
          target = idMatches[0];
        }
      }
      if (!target || !target.key) return null;
      requested[String(target.key)] = quantityValue;
    } else {
      if (!body.updates || typeof body.updates !== 'object' || Array.isArray(body.updates)) return null;
      for (var updateKey in body.updates) {
        var updateQuantity = Number(body.updates[updateKey]);
        if (!isFinite(updateQuantity) || updateQuantity < 0 || Math.floor(updateQuantity) !== updateQuantity) return null;
        var keyText = String(updateKey);
        var line = null;
        if (keyText.indexOf(':') >= 0) {
          line = cart.items.filter(function (item) { return String(item.key) === keyText; })[0] || null;
        } else {
          var variantNumber = Number(keyText);
          var variantMatches = cart.items.filter(function (item) { return variantId(item) === variantNumber; });
          if (variantMatches.length !== 1) return null;
          line = variantMatches[0];
        }
        if (!line || !line.key) return null;
        requested[String(line.key)] = updateQuantity;
      }
    }

    var prospective = [];
    cart.items.forEach(function (item) {
      var key = String(item.key || '');
      var nextQuantity = key in requested ? requested[key] : quantity(item);
      if (nextQuantity > 0) {
        prospective.push({
          key: key,
          quantity: nextQuantity,
          product_id: item.product_id,
          variant_id: variantId(item),
          handle: item.handle || item.product_handle,
          price: item.price,
          final_price: item.final_price,
          selling_plan_allocation: item.selling_plan_allocation,
          selling_plan: item.selling_plan,
          properties: properties(item)
        });
      }
    });
    var projectedCart = { items: prospective };
    ['currency', 'presentment_currency', 'currency_code', 'country', 'country_code', 'presentmentCurrencyRate', 'market', 'localization'].forEach(function (key) {
      if (cart[key] !== undefined) projectedCart[key] = cart[key];
    });
    var repair = planCartRepairs(projectedCart);
    if (!repair.changed) return null;

    var updates = {};
    for (var requestedKey in requested) updates[requestedKey] = requested[requestedKey];
    for (var repairKey in repair.updates) updates[repairKey] = repair.updates[repairKey];
    return {
      updates: updates,
      attributes: body.attributes,
      sections: body.sections,
      sections_url: body.sections_url
    };
  }

  root.GBK98CartGuard = {
    planCartRepairs: planCartRepairs,
    planMutationAugment: planMutationAugment,
    reconcileOnce: reconcileOnce
  };

  if (!root.document || !root.fetch || root.__gbk98CartGuardInit) return;
  root.__gbk98CartGuardInit = true;

  var document = root.document;
  var timer = null;
  var busy = false;
  var rerun = false;
  var retries = 0;
  var observers = [];
  var CART_EVENTS = ['cart:refresh', 'cart:updated', 'cart:change', 'cart:added'];

  /* JSON-template cart sections have dynamic ids (template--*__cart-items); the
     request key must come from each wrapper's data-id, never the literal filename. */
  function cartPageSectionId(domId) {
    var el = document.getElementById(domId);
    return (el && el.getAttribute && el.getAttribute('data-id')) || null;
  }

  function sectionList() {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var itemsId = cartPageSectionId('main-cart-items');
    var footerId = cartPageSectionId('main-cart-footer');
    if (itemsId) sections.push(itemsId);
    if (footerId) sections.push(footerId);
    return sections;
  }

  function sectionDocument(html) {
    return new root.DOMParser().parseFromString(html, 'text/html');
  }

  function sectionSource(html, selector) {
    if (!html) return null;
    return sectionDocument(html).querySelector(selector);
  }

  /* Shrine collapses .drawer__header/.cart-drawer__body/.drawer__footer to height 0
     whenever <cart-drawer> carries is-empty; a stale root class is the white-panel
     mechanism, so the root class must always match the repaired item_count. */
  function setRootEmptyState(empty) {
    var drawerRoot = document.querySelector('cart-drawer');
    if (drawerRoot && drawerRoot.classList) drawerRoot.classList.toggle('is-empty', empty);
    var inner = drawerRoot && drawerRoot.querySelector ? drawerRoot.querySelector('.drawer__inner') : null;
    if (!empty && inner && inner.classList) inner.classList.remove('is-empty');
    var cartRoot = document.querySelector('cart-items');
    if (cartRoot && cartRoot.classList) cartRoot.classList.toggle('is-empty', empty);
  }

  function renderSections(data) {
    var sections = data && data.sections || null;
    if (!sections) return;
    var empty = !!data && data.item_count === 0;
    var drawerHtml = sections['cart-drawer'];
    var swapped = false;
    /* Theme-native repaint: swap the whole .drawer__inner contents (header count,
       items, footer totals — and for an emptied cart the drawer__inner-empty block
       plus disabled footer all come re-rendered). The overlay and the cart-drawer
       root with its listeners stay untouched; custom elements re-upgrade on insert
       (live-proven on the add flow). Items-only swap remains the fallback. */
    var innerSource = sectionSource(drawerHtml, '.drawer__inner');
    var innerTarget = document.querySelector('cart-drawer .drawer__inner');
    if (innerSource && innerTarget) {
      innerTarget.innerHTML = innerSource.innerHTML;
      swapped = true;
    }
    if (!swapped) {
      var itemsSource = sectionSource(drawerHtml, 'cart-drawer-items');
      var itemsTarget = document.querySelector('cart-drawer-items');
      if (itemsSource && itemsTarget) itemsTarget.replaceWith(itemsSource);
    }
    setRootEmptyState(empty);
    var iconHtml = sections['cart-icon-bubble'];
    var iconTarget = document.querySelector('#cart-icon-bubble');
    if (iconHtml && iconTarget) {
      /* The rendered section has no #cart-icon-bubble wrapper (that div lives in the
         header); fall back to the .shopify-section wrapper's contents. */
      var iconSource = sectionSource(iconHtml, '#cart-icon-bubble') || sectionSource(iconHtml, '.shopify-section');
      if (iconSource) iconTarget.innerHTML = iconSource.innerHTML;
    }
    var itemsId = cartPageSectionId('main-cart-items');
    if (itemsId) {
      var pageSource = sectionSource(sections[itemsId], '#main-cart-items');
      var pageTarget = document.getElementById('main-cart-items');
      if (pageSource && pageTarget) pageTarget.replaceWith(pageSource);
    }
    var footerId = cartPageSectionId('main-cart-footer');
    if (footerId) {
      var footerSource = sectionSource(sections[footerId], '#main-cart-footer');
      var footerTarget = document.getElementById('main-cart-footer');
      if (footerSource && footerTarget) footerTarget.replaceWith(footerSource);
    }
  }

  /* Customer-visible feedback: when a FREE gift line vanishes while real items
     remain, say why instead of letting rows silently disappear. */
  function showGiftNotice() {
    try {
      var hosts = [
        document.querySelector('cart-drawer .drawer__inner'),
        document.getElementById('main-cart-items')
      ];
      hosts.forEach(function (host) {
        if (!host || host.querySelector('.gbk98-gift-note')) return;
        var note = document.createElement('div');
        note.className = 'gbk98-gift-note';
        note.setAttribute('role', 'status');
        note.style.cssText = 'margin:10px 14px;padding:10px 12px;border:1px solid #f1c8c4;background:#fdf1f0;color:#9c2f27;font-size:13px;font-weight:600;border-radius:10px;line-height:1.35;';
        note.textContent = 'FREE gift removed \u2014 your cart no longer qualifies for it.';
        host.insertBefore(note, host.firstChild);
        root.setTimeout(function () { if (note && note.remove) note.remove(); }, 7000);
      });
    } catch (error) {}
  }

  function dispatchUpdate(data) {
    CART_EVENTS.forEach(function (name) {
      try {
        document.dispatchEvent(new root.CustomEvent(name, { detail: { data: data, source: 'gbk98-cart-guard' } }));
      } catch (error) {}
    });
  }

  /* Narrow fetch wrapper: keeps a fresh cart snapshot from every cart response and
     rewrites a theme change/update that would strand an invalid gift (see
     planMutationAugment). Anything unrecognized passes through untouched. */
  var lastCart = null;
  function rememberCart(data) {
    if (!data || !Array.isArray(data.items)) return;
    try {
      /* Feedback on every path (intercepted or theme-native): a gift line that
         vanishes while real items remain gets one visible explanation. */
      if (lastCart && Array.isArray(lastCart.items) && data.item_count > 0
          && lastCart.items.some(isExactGift) && !data.items.some(isExactGift)) {
        root.setTimeout(showGiftNotice, 120);
      }
    } catch (error) {}
    lastCart = data;
  }

  /* Builder 1.4.2: only a recent, complete response from an idle cart request can
     prove an ordinary cart needs no mutation planning. Shared DOM snapshots and
     add replies do not prove the whole cart is current. A read through the
     store's 400ms coalescer is not freshness proof either (it ignores no-store).
     Writes, overlapping requests and page lifecycle changes invalidate trust;
     managed carts always keep the existing fresh-read/atomic-update path. */
  var PLAN_HINT_MAX_AGE = 120000;
  var planHint = null;
  var planHintAt = 0;
  var planEpoch = 0;
  var planRequestSeq = 0;
  var cartWritesOpen = 0;

  function completeCart(data) {
    if (!data || !Array.isArray(data.items) || typeof data.item_count !== 'number') return false;
    var count = 0;
    for (var i = 0; i < data.items.length; i++) {
      var item = data.items[i];
      if (!item || typeof item.key !== 'string' || !item.key || !variantId(item)
          || !Object.prototype.hasOwnProperty.call(item, 'properties')
          || (item.properties !== null && (typeof item.properties !== 'object' || Array.isArray(item.properties)))
          || typeof item.quantity !== 'number' || item.quantity < 1 || Math.floor(item.quantity) !== item.quantity) return false;
      count += item.quantity;
    }
    return count === data.item_count;
  }

  function forgetPlanHint() {
    planHint = null;
    planHintAt = 0;
  }

  function invalidatePlanHint() {
    planEpoch += 1;
    forgetPlanHint();
  }

  function cartLineKeys(cart) {
    return cart.items.map(function (item) { return String(item && item.key || ''); }).sort().join('\n');
  }

  function trustPlanHint(data, seq, requestId, wasIdle, requestedAt) {
    var age = Date.now() - requestedAt;
    if (!wasIdle || !completeCart(data) || cartWritesOpen > 0 || seq !== planEpoch
        || requestId !== planRequestSeq || document.visibilityState === 'hidden'
        || age < 0 || age > PLAN_HINT_MAX_AGE) return;
    planHint = data;
    planHintAt = requestedAt;
  }

  function checkSharedHint(data, seq) {
    /* Conflicting shared data can revoke a hint, but can never create one. */
    if (seq === planEpoch && planHint && completeCart(data)
        && cartLineKeys(planHint) !== cartLineKeys(data)) invalidatePlanHint();
  }

  function currentPlanHint() {
    if (!planHint || cartWritesOpen > 0) return null;
    var age = Date.now() - planHintAt;
    if (document.visibilityState === 'hidden' || age < 0 || age > PLAN_HINT_MAX_AGE) {
      forgetPlanHint();
      return null;
    }
    return planHint;
  }

  function managedPlanLine(item) {
    if (isExactGift(item) || isBundleRewardGiftCandidate(item) || rewardPaidLine(item)) return true;
    var props = properties(item);
    return ['_bos_exp', '_bos_gift', '_gbk98_offer', '_gbk98_role', '_gbk98_bundle'].some(function (name) {
      return props[name] !== undefined && props[name] !== null && String(props[name]) !== '';
    });
  }

  function ordinaryPlanHint(cart, url, bodyText) {
    if (!cart || cart.items.some(managedPlanLine)) return false;
    var augment = null;
    try { augment = planMutationAugment(cart, url, bodyText); } catch (error) { return false; }
    return !augment;
  }

  var nativeFetch = root.fetch.bind(root);
  root.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : String(input && input.url || ''); } catch (error) {}
    var request = null;
    var passthroughInit = init;
    var cartWrite = /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(url);
    var cartRead = !cartWrite && /\/cart\.js(?:[?#]|$)/.test(url);
    var requestedAt = Date.now();
    var wasIdle = cartWritesOpen === 0 && document.visibilityState !== 'hidden';
    var requestId = cartWrite || cartRead ? ++planRequestSeq : 0;
    var hintCart = null;
    if (cartWrite && init && init.__gbk98FreshPlan !== true && typeof init.body === 'string' && /\/cart\/(change|update)\.js/.test(url)) {
      try { hintCart = currentPlanHint(); } catch (error) { hintCart = null; }
    }
    var requestSeq = planEpoch;
    if (cartWrite) {
      invalidatePlanHint();
      requestSeq = planEpoch;
      cartWritesOpen += 1;
    }
    try {
      if (init && init.__gbk98FreshPlan === true) {
        var freshPlanInit = {};
        for (var freshOption in init) {
          if (freshOption !== '__gbk98FreshPlan') freshPlanInit[freshOption] = init[freshOption];
        }
        passthroughInit = freshPlanInit;
      } else if (hintCart && ordinaryPlanHint(hintCart, url, init.body)) {
        /* Planned from the trusted hint: an ordinary cart has nothing to repair,
           so the original change/update runs once with no preflight. */
        /* The single native call is below the planning try/catch, so a
           synchronous fetch error can never cause a second original write. */
      } else if (init && typeof init.body === 'string' && /\/cart\/(change|update)\.js/.test(url)) {
        /* The remembered cart is only a hint: fetch the current cart before
           planning so a stale snapshot cannot remove the wrong line or leave a
           dependent gift behind. The original request runs once if preflight or
           the planner cannot prove an atomic repair is needed. */
        request = nativeFetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response || !response.ok) return null;
          return response.json();
        }, function () {
          return null;
        }).catch(function () {
          return null;
        }).then(function (freshCart) {
          if (!freshCart || !Array.isArray(freshCart.items)) return nativeFetch(input, init);
          rememberCart(freshCart);
          var augment = null;
          try { augment = planMutationAugment(freshCart, url, init.body); } catch (error) { augment = null; }
          if (!augment) return nativeFetch(input, init);
          var rewritten = {};
          for (var option in init) rewritten[option] = init[option];
          rewritten.method = 'POST';
          rewritten.body = JSON.stringify({
            updates: augment.updates,
            attributes: augment.attributes,
            sections: augment.sections,
            sections_url: augment.sections_url
          });
          return nativeFetch('/cart/update.js?kaching_bundles=true', rewritten);
        });
      }
    } catch (error) { request = null; }
    if (!request) {
      try {
        request = nativeFetch(input, passthroughInit);
      } catch (error) {
        if (cartWrite) cartWritesOpen = Math.max(0, cartWritesOpen - 1);
        throw error;
      }
    }
    if (/\/cart(\/(change|update|add|clear)\.js|\.js)/.test(url)) {
      request.then(function (response) {
        try { response.clone().json().then(rememberCart, function () {}); } catch (error) {}
      }, function () {});
    }
    if (cartWrite || cartRead) watchPlanHint(request, url, cartWrite, requestSeq, requestId, wasIdle, requestedAt);
    return request;
  };

  /* The original response/promise stays untouched. A failed or partial write
     leaves no hint; a delayed or overlapping reply cannot restore an old one. */
  function watchPlanHint(request, url, cartWrite, requestSeq, requestId, wasIdle, requestedAt) {
    var settled = false;
    function settle() {
      if (settled) return;
      settled = true;
      if (cartWrite) cartWritesOpen = Math.max(0, cartWritesOpen - 1);
    }
    function unknownResult() {
      settle();
      if (requestId === planRequestSeq) forgetPlanHint();
    }
    try {
      request.then(function (response) {
        try {
          if (!response || !response.ok || typeof response.clone !== 'function') {
            unknownResult();
            return;
          }
          response.clone().json().then(function (data) {
            settle();
            if (requestId === planRequestSeq) forgetPlanHint();
            if (/\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url)) return;
            if (!cartWrite && root.__gbCartCoalesce) return;
            trustPlanHint(data, requestSeq, requestId, wasIdle, requestedAt);
          }, unknownResult);
        } catch (error) { unknownResult(); }
      }, unknownResult);
    } catch (error) { unknownResult(); }
  }

  /* Another tab or a restored page may have changed the cart. */
  if (document.addEventListener) {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') invalidatePlanHint();
    });
  }
  if (root.addEventListener) {
    root.addEventListener('pagehide', invalidatePlanHint);
    root.addEventListener('pageshow', function (event) {
      if (event && event.persisted) invalidatePlanHint();
    });
  }
  var guardFetch = root.fetch;

  function run() {
    timer = null;
    if (busy) {
      rerun = true;
      return;
    }
    busy = true;
    var runSeq = planEpoch;
    reconcileFromSharedSnapshot(root.fetch.bind(root), root.location && root.location.pathname || '/cart', sectionList()).then(function (result) {
      retries = 0;
      rememberCart(result.data || result.cart);
      checkSharedHint(result.data || result.cart, runSeq);
      if (result.changed) {
        renderSections(result.data);
        dispatchUpdate(result.data);
      }
      observeCartSurfaces();
    }).catch(function () {
      retries += 1;
      if (retries <= 2) root.setTimeout(function () { schedule(0); }, 700);
    }).then(function () {
      busy = false;
      if (rerun) {
        rerun = false;
        schedule(80);
      }
    });
  }

  function schedule(delay) {
    if (busy) {
      rerun = true;
      return;
    }
    if (timer) root.clearTimeout(timer);
    timer = root.setTimeout(run, typeof delay === 'number' ? delay : 80);
  }

  function mutationTouchesCart(mutation) {
    var target = mutation && mutation.target;
    if (target && target.nodeType === 1 && target.closest && target.closest('#CartDrawer-CartItems, cart-drawer-items, #main-cart-items')) return true;
    return Array.prototype.some.call(mutation && mutation.addedNodes || [], function (node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.matches && node.matches('#CartDrawer-CartItems, cart-drawer-items, #main-cart-items')) return true;
      return !!(node.querySelector && node.querySelector('#CartDrawer-CartItems, cart-drawer-items, #main-cart-items'));
    });
  }

  function observeCartSurfaces() {
    if (!root.MutationObserver) return;
    /* Observe stable roots only: cart-items survives #main-cart-items swaps, so no
       observer is orphaned or re-attached after a repair. */
    ['cart-drawer', 'cart-items'].forEach(function (selector) {
      var surface = document.querySelector(selector);
      if (!surface || surface.__gbk98CartGuardObserved) return;
      surface.__gbk98CartGuardObserved = true;
      var observer = new root.MutationObserver(function (mutations) {
        if (Array.prototype.some.call(mutations || [], mutationTouchesCart)) schedule(80);
      });
      observer.observe(surface, { childList: true, subtree: true });
      observers.push(observer);
    });
  }

  /* Capture-phase interception of the drawer/cart-page remove and minus controls.
     App scripts overwrite window.fetch after this guard loads (last-writer wins), so
     the fetch wrapper alone cannot be relied on. When a click would reduce a paid
     bundle line below its gift threshold, the theme's own request would be rejected
     by the server-side Gift Eligibility Guard (422) and strand the customer; here it
     is replaced with ONE atomic update that also drops the now-invalid gifts, so the
     result stays valid and the gift disappears in the same paint. Clicks on carts
     without exact gift lines are never touched. */
  function offerLineIndexFor(target) {
    if (!target || !target.closest) return null;
    var carrier = target.closest('[data-index]');
    if (!carrier) {
      var quantityHost = target.closest('quantity-input');
      carrier = quantityHost && quantityHost.querySelector ? quantityHost.querySelector('[data-index]') : null;
    }
    var index = carrier ? Number(carrier.getAttribute('data-index')) : NaN;
    if (!isFinite(index) || index < 1) return null;
    return index;
  }

  function offerLineKeyFor(control) {
    /* Shrine's remove control carries the exact line key in its change URL;
       prefer it over an index into a possibly stale snapshot. */
    if (!control || !control.querySelector) return null;
    var anchor = control.tagName === 'A' ? control : control.querySelector('a[href*="/cart/change"]');
    var href = anchor && anchor.getAttribute ? anchor.getAttribute('href') : null;
    if (!href) return null;
    var match = href.match(/[?&]id=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function interceptCartControls(event) {
    try {
      if (event.type === 'click' && interceptedRecently) {
        /* this gesture was already handled from touchend/pointerup */
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        return;
      }
      if (!lastCart || !Array.isArray(lastCart.items)) return;
      if (!lastCart.items.some(isExactGift) && !lastCart.items.some(isBundleRewardGiftCandidate)) return;
      var target = event.target;
      if (!target || !target.closest) return;
      var removeControl = target.closest('cart-remove-button');
      var minusControl = target.closest('quantity-input button[name="minus"]');
      if (!removeControl && !minusControl) return;
      var control = removeControl || minusControl;
      var domKey = removeControl ? offerLineKeyFor(removeControl) : null;
      var line = null;
      if (domKey) {
        line = lastCart.items.filter(function (item) { return String(item.key) === domKey; })[0] || null;
        if (!line) return;
      }
      var index = offerLineIndexFor(control) || offerLineIndexFor(target);
      if (!line) {
        if (!index) return;
        line = lastCart.items[index - 1];
      } else if (!index) {
        index = lastCart.items.indexOf(line) + 1;
      }
      if (!line || !line.key) return;
      var current = quantity(line);
      var nextQuantity = removeControl ? 0 : current - 1;
      if (!removeControl && current <= 1) return; /* theme no-ops a minus at 1 — keep parity */
      var changeBody = {
        id: String(line.key),
        quantity: nextQuantity,
        sections: sectionList(),
        sections_url: root.location && root.location.pathname || '/cart'
      };
      var serializedChange = JSON.stringify(changeBody);
      var hint = planMutationAugment(lastCart, '/cart/change.js', serializedChange);
      if (!hint) return; /* the change stays valid — let the theme handle it natively */
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      interceptedRecently = true;
      root.setTimeout(function () { interceptedRecently = false; }, 400);
      var mutation;
      if (root.fetch === guardFetch) {
        mutation = readJson(root.fetch.bind(root), '/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: serializedChange
        });
      } else {
        mutation = readJson(nativeFetch, '/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }).then(function (freshCart) {
          rememberCart(freshCart);
          var freshPlan = planMutationAugment(freshCart, '/cart/change.js', serializedChange);
          if (!freshPlan) {
            return readJson(root.fetch.bind(root), '/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: serializedChange
            });
          }
          return readJson(root.fetch.bind(root), '/cart/update.js?kaching_bundles=true', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            __gbk98FreshPlan: true,
            body: JSON.stringify({
              updates: freshPlan.updates,
              attributes: freshPlan.attributes,
              sections: freshPlan.sections || sectionList(),
              sections_url: freshPlan.sections_url || (root.location && root.location.pathname) || '/cart'
            })
          });
        });
      }
      mutation.then(function (data) {
        rememberCart(data);
        renderSections(data);
        dispatchUpdate(data);
      }).catch(function () {
        schedule(0); /* fall back to a fresh reconcile pass */
      });
    } catch (error) {}
  }

  var interceptedRecently = false;
  function interceptWithDedupe(event) {
    /* A mobile tap can act on touchend/pointerup before the synthesized click;
       evaluate the interception there too. pointerup from a mouse defers to the
       click handler, and a gesture already intercepted is not re-run. */
    if (event.type === 'pointerup' && event.pointerType === 'mouse') return;
    if (interceptedRecently) return;
    interceptCartControls(event);
  }

  function ready() {
    observeCartSurfaces();
    document.addEventListener('click', interceptCartControls, true);
    document.addEventListener('touchend', interceptWithDedupe, { capture: true, passive: false });
    document.addEventListener('pointerup', interceptWithDedupe, { capture: true, passive: false });
    CART_EVENTS.forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (event && event.detail && event.detail.source === 'gbk98-cart-guard') return;
        schedule(50);
      });
    });
    schedule(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})(typeof window !== 'undefined' ? window : this);
